export default __webpack_public_path__ + "static/media/show-cup-2.47d28d1b.webp";